module.exports = __webpack_public_path__ + "img/bedGreen1.33bd2d75.png";